"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var _a;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConverterFromNext = void 0;

var ArbitraryWithContextualShrink_1 = require("./ArbitraryWithContextualShrink");

var ConverterToNext_1 = require("./ConverterToNext");

var Shrinkable_1 = require("./Shrinkable");

var identifier = '__ConverterFromNext__';

function fromNextValueToShrinkableFor(arb) {
  return function fromNextValueToShrinkable(v) {
    var value_ = v.value_;

    var shrinker = function shrinker() {
      return arb.shrink(value_, v.context).map(fromNextValueToShrinkable);
    };

    if (!v.hasToBeCloned) {
      return new Shrinkable_1.Shrinkable(value_, shrinker);
    }

    return new Shrinkable_1.Shrinkable(value_, shrinker, function () {
      return v.value;
    });
  };
}

var ConverterFromNext = /*#__PURE__*/function (_ArbitraryWithContext) {
  _inherits(ConverterFromNext, _ArbitraryWithContext);

  var _super = _createSuper(ConverterFromNext);

  function ConverterFromNext(arb, legacyShrunkOnceContext) {
    var _this;

    var biasFactor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

    _classCallCheck(this, ConverterFromNext);

    _this = _super.call(this);
    _this.arb = arb;
    _this.legacyShrunkOnceContext = legacyShrunkOnceContext;
    _this.biasFactor = biasFactor;
    _this[_a] = true;
    _this.toShrinkable = fromNextValueToShrinkableFor(arb);
    return _this;
  }

  _createClass(ConverterFromNext, [{
    key: "generate",
    value: function generate(mrng) {
      var g = this.arb.generate(mrng, this.biasFactor);
      return this.toShrinkable(g);
    }
  }, {
    key: "contextualShrink",
    value: function contextualShrink(value, context) {
      return this.arb.shrink(value, context).map(function (v) {
        return [v.value_, v.context];
      });
    }
  }, {
    key: "shrunkOnceContext",
    value: function shrunkOnceContext() {
      return this.legacyShrunkOnceContext;
    }
  }, {
    key: "filter",
    value: function filter(refinement) {
      return ConverterFromNext.convertIfNeeded(this.arb.filter(refinement));
    }
  }, {
    key: "map",
    value: function map(mapper) {
      return ConverterFromNext.convertIfNeeded(this.arb.map(mapper));
    }
  }, {
    key: "chain",
    value: function chain(fmapper) {
      return ConverterFromNext.convertIfNeeded(this.arb.chain(function (t) {
        var fmapped = fmapper(t);
        if (ConverterFromNext.isConverterFromNext(fmapped)) return fmapped.arb;else return new ConverterToNext_1.ConverterToNext(fmapped);
      }));
    }
  }, {
    key: "noShrink",
    value: function noShrink() {
      return ConverterFromNext.convertIfNeeded(this.arb.noShrink());
    }
  }, {
    key: "withBias",
    value: function withBias(freq) {
      return new ConverterFromNext(this.arb, this.legacyShrunkOnceContext, freq);
    }
  }, {
    key: "noBias",
    value: function noBias() {
      return ConverterFromNext.convertIfNeeded(this.arb.noBias());
    }
  }], [{
    key: "isConverterFromNext",
    value: function isConverterFromNext(arb) {
      return identifier in arb;
    }
  }, {
    key: "convertIfNeeded",
    value: function convertIfNeeded(arb) {
      if (ConverterToNext_1.ConverterToNext.isConverterToNext(arb)) return arb.arb;else return new ConverterFromNext(arb);
    }
  }]);

  return ConverterFromNext;
}(ArbitraryWithContextualShrink_1.ArbitraryWithContextualShrink);

exports.ConverterFromNext = ConverterFromNext;
_a = identifier;